import {useEffect, useState, useRef} from 'react'

export const useIsOverflowing = (deps: any[] = []) => {
    const [isOverflowing, setIsOverflowing] = useState(false)
    const containerRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const checkOverflow = () => {
            const element = containerRef.current
            if (!element) return

            const isContentOverflowing =
                element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth
            setIsOverflowing(isContentOverflowing)
        }

        checkOverflow()
        window.addEventListener('resize', checkOverflow)

        return () => window.removeEventListener('resize', checkOverflow)
    }, [...deps])

    return {isOverflowing, containerRef}
}
